import { CircleAlert, CircleCheck, Info, TriangleAlert, X } from 'lucide-react';
import { Toaster } from 'sonner';
import { TOAST_MS } from '@/lib/toast';

/**
 * The one toast stack (hotfix 2026-09-28), mounted once at the root so every page — signed in or not — shows it:
 * bottom-right, each toast with its close button, expanded so several stand one above the other and never overlap.
 * Its look is the product's (tokens, font, radius) and lives in `styles/toast.css`; that file also lifts the stack
 * over the Map's minimap and its zoom dock, and makes it a full-width strip above the safe area on a phone.
 *
 * Mounted before the routes, so its subscription is live before any page effect says something.
 */
export function AppToaster() {
  return (
    <Toaster
      position="bottom-right"
      closeButton
      expand
      visibleToasts={5}
      duration={TOAST_MS}
      gap={8}
      offset={{ bottom: 16, right: 16 }}
      mobileOffset={{ bottom: 'calc(12px + env(safe-area-inset-bottom))', left: 12, right: 12 }}
      containerAriaLabel="Thông báo nhanh"
      className="app-toaster"
      icons={{
        success: <CircleCheck aria-hidden="true" />,
        info: <Info aria-hidden="true" />,
        warning: <TriangleAlert aria-hidden="true" />,
        error: <CircleAlert aria-hidden="true" />,
        close: <X aria-hidden="true" />,
      }}
      toastOptions={{ closeButtonAriaLabel: 'Đóng thông báo' }}
    />
  );
}
